import React, { Component } from "react";
import "./home.scss";
// import Splash from "./splash";
import SplashDark from "./splashDark";
import Game from "./Game";
import { GlobalContext } from "./context";
export default class Home extends Component {
  static contextType = GlobalContext;
  render() {
    const { state, setState } = this.context;
    return (
      <>
        {state.show === "game" ? (
          <Game />
        ) : (
          <SplashDark beginGame={(toShow) => {setState({ show: toShow })}} />
        )}
      </>
    );
  }
}
